import { Facility } from "@/types";
import { createContext } from "react";

export interface FacilitiesContextType {
    facilities: Facility[];
}

export const FacilitiesContext = createContext<FacilitiesContextType | null>(
    null,
);
